import type { RouteLocation } from 'vue-router';
import { popQueryOrParam } from '@/helpers/routerUtils';

/**
 * Destino das rotas do fluxo LEGADO de ofertas, mantidas registradas apenas como
 * redirecionamento porque links antigos (e-mail, SMS, push, histórico do navegador)
 * continuam apontando para elas.
 */
export function redirectLegacyOfertaToCheckout(to: RouteLocation): string {
  const api = popQueryOrParam(to.params.api);
  const dividaId = popQueryOrParam(to.params.dividaId);
  if (!api || !dividaId) {
    return '/';
  }

  const ofertaId = popQueryOrParam(to.params.ofertaId);
  if (ofertaId) {
    return `/divida/${api}/${dividaId}/checkout/${ofertaId}`;
  }

  return `/divida/${api}/${dividaId}/checkout`;
}
